import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TableEntreeState {
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
  sorting: Array<{ id: string; desc: boolean }>;
  columnFilters: any[];
  columnVisibility: Record<string, boolean>;
  columnSizing?: Record<string, number>;
  density: string;
  globalFilter?: string;
  showColumnFilters: boolean;
  showGlobalFilter: boolean;
}

export interface TableRefEntreeState {
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
  sorting: any[];
  columnFilters: any[];
  columnVisibility: Record<string, boolean>;
  density: string;
  globalFilter?: string;
  showColumnFilters: boolean;
  showGlobalFilter: boolean;
}

export interface TablesState {
  tableEntreeState: TableEntreeState;
  tableRefEntreeState: TableRefEntreeState;
}

const initialState: TablesState = {
  tableEntreeState: {
    pagination: { pageIndex: 0, pageSize: 10 },
    sorting: [{ id: 'cle', desc: false }],
    columnFilters: [],
    columnVisibility: {
      // Labels masqués par défaut
      label1: false,
      label2: false,
      label3: false,
      label4: false,
      label5: false,
      label6: false,
      label7: false,
      // Entrées 3-7 masquées par défaut
      entree3: false,
      entree4: false,
      entree5: false,
      entree6: false,
      entree7: false,
      // Autres colonnes masquées par défaut
      autres: false,
      definition: false,
    },
    density: 'compact',
    globalFilter: undefined,
    showColumnFilters: false,
    showGlobalFilter: false,
  },
  tableRefEntreeState: {
    pagination: { pageIndex: 0, pageSize: 5 },
    sorting: [],
    columnFilters: [],
    columnVisibility: { idNote: false },
    density: 'compact',
    globalFilter: undefined,
    showColumnFilters: false,
    showGlobalFilter: false,
  },
};

export const tableSlice = createSlice({
  name: 'tables',
  initialState,
  reducers: {
    setTableEntreeState(state, action: PayloadAction<TableEntreeState>) {
      state.tableEntreeState = action.payload;
    },
    setTableRefEntreeState(state, action: PayloadAction<TableRefEntreeState>) {
      state.tableRefEntreeState = action.payload;
    },
  },
});

export const GetTableEntreeState = (state: any) => state.tables.tableEntreeState;
export const GetTableRefEntreeState = (state: any) => state.tables.tableRefEntreeState;

export default tableSlice.reducer;
export const { setTableEntreeState, setTableRefEntreeState } = tableSlice.actions;
